import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeModalAction } from '../../../actions/modal';
import { generateAssetsBarcode } from '../../../actions/inventory';
import Form from '../../../common/Form';
import Input from '../../../common/Form/Input';
import { useForm } from 'react-hook-form';
import Radio from '../../../common/Form/Radio';

const formName = 'downloadQrCode';

const formatOptions = [
    { value: 'pdf', name: 'format', label: 'PDF' },
    { value: 'html', name: 'format', label: 'HTML' },
];



export default function DownloadBulkQR({ assets, organisation }) {
    const dispatch = useDispatch();
    const formButtonLoading = useSelector((state) => state.loading.formButtonLoading);

    let defaultValues = {
        format: formatOptions[0].value
    };

    const handleSubmit = (formData) => {
        const payload = { require_html: formData.format === 'html' ? true : false };
        if (assets.length > 0) payload.assets = assets;
        if (parseInt(formData.quantity) > 0) payload.quantity = parseInt(formData.quantity);
        dispatch(generateAssetsBarcode({ payload, formName }));
    };

    const methods = useForm({ defaultValues, mode: 'all' });

    return (
        <>
            <Form
                defaultValues={defaultValues}
                onSubmit={handleSubmit}
                onCancel={() => dispatch(closeModalAction())}
                showSubmit
                submitContainerClassName='flex gap-2 justify-end py-4 px-4'
                isLoading={formButtonLoading[formName]}
                methods={methods}
                submitButtonText={'Print'}
            >
                {
                    assets.length > 0 ?
                        <>
                            <div className='px-5 pt-5 text-scogoprimary text-font13'>
                                <Radio name='format' options={formatOptions} />
                            </div>
                            <div className={`px-5  pb-5 flex justify-center text-scogoorange text-font13`}>Click Print to download pdf</div>
                        </> : null
                }

                {
                    assets.length === 0 ?
                        <div className='w-full px-3'>
                            <Input type={'number'} label={'Quantity'} name={'quantity'} required pattern={/^[1-9][0-9]*$/} />
                        </div> : null
                }
            </Form>
        </>
    );
}
